export function buildSurveyListTableHeaders({ t }) {
  return [
    {
      value: "title",
      text: t("survey.title"),
      thClass: "w-[14rem]",
      tdClass: "max-w-[14rem] min-w-[10rem]",
      disabled: true,
    },
    {
      value: "validityPeriod",
      text: t("survey.validityPeriod"),
      thClass: "w-[14rem]",
      tdClass: "max-w-[16rem] min-w-[12rem]",
    },
    {
      value: "maxShows",
      text: t("survey.maxShows"),
      thClass: "w-[8rem]",
      tdClass: "max-w-[8rem] min-w-[6rem]",
    },
  ];
}
